module.exports = __webpack_public_path__ + "img/center.443de679.gif";